import React from 'react';
import styled from '@emotion/styled';

import Button from '../../Common/Button';

import { DESKTOP_START_QUERY } from '../../../styling/mixins/responsive';

const NavButton = styled(Button)`
  align-items: center;
  display: flex;
  font-weight: 700;
  justify-content: center;
  letter-spacing: 2px;
  text-transform: uppercase;
  background-color: transparent;
  border: none;
  margin-bottom: 0rem;
  transition: opacity 0.3s ease-in-out;
  z-index: 1;

  @media (${DESKTOP_START_QUERY}) {
    font-size: 0.75rem;
    color: white;
    height: 1.75rem;
    line-height: 1.43;
    border-bottom: solid 1px;
    padding: 0rem;
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: transparent;
      border-color: white;
      color: white;
      border-bottom: solid 1px;
      opacity: 0.7;
      transition: opacity 0.3s ease-in-out;
    }
  }
`;

export default React.memo(NavButton);
